import { render, staticRenderFns } from "./rssi.vue?vue&type=template&id=4beaa89f&scoped=true&"
import script from "./rssi.vue?vue&type=script&lang=js&"
export * from "./rssi.vue?vue&type=script&lang=js&"
import style0 from "./rssi.vue?vue&type=style&index=0&id=4beaa89f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beaa89f",
  null
  
)

export default component.exports